<script>
  export let value;
  export let label;
  export let disabled = false;
</script>

<label class:disabled
  >{label}
  <input
    type="text"
    autocomplete="number"
    id="warp-count"
    on:input
    bind:value
    {disabled}
  />
</label>

<style>
  label {
    margin-bottom: 4px;
  }
  input {
    margin: 4px 0 0.5em 0;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 10px 8px;
    background-color: white;
    border: 1px solid transparent;
    display: block;
    width: 100%;
    font-size: 16px;
  }

  label.disabled,
  input:disabled {
    color: #ccc;
  }

  input:not(:disabled):hover {
    border: 1px solid var(--color-4);
    cursor: pointer;
  }
</style>
